import React, { useEffect, useState } from 'react';
import { CssBaseline, TextField, Link, Grid, Typography, FormControl, OutlinedInput, InputAdornment, IconButton, CircularProgress, Button, Box } from '@mui/material';
import { connect } from 'react-redux';
import { ProfileSVG, ShowPasswordSVG, ShowPasswordOffSVG, LockSVG, LoginSVG } from '../../components';
import loginService from '../../services/login';
import { EmailSVG } from '../../components/svg/EmailSVG';
import * as auth from '../../store/ducks/auth.duck';
import { createCaptcha, deletCaptcha, showCaptcha, RECAPTCHA_SITE_KEY as SITE_KEY, getCoreLocale } from '../../helpers';
import { useHistory } from 'react-router';
import platforms from '../../constants/users/platforms';
import '../../styles/sass/auth/login.scss';
import { useTranslation, Trans } from 'react-i18next';
import LanguageSelector from '../../components/languageSelector';
import { palette } from '../../styles/theme';
import { getInitialRoute } from '../../helpers/RouteHelpers';
import CustomAlert from '../../components/Alert';

export const Login = props => {
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const recoverPassword = localStorage.getItem('recoverToken');
    const [loginForm, setLoginForm] = useState({
        account: '',
        password: '',
        recovery: ''
    });
    const [values, setValues] = React.useState({
        showPassword: false,
        errorLogin: false,
        errorEmail: false,
    });

    const [forgotPass, setForgotPass] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Alert states
    const [alert, setAlert] = useState({
        severity: '',
        title: '',
        description: '',
        className: ''
    });
    const [openAlert, setOpenAlert] = useState(false);

    // recaptcha data
    let captchaToken = '';
    // reCaptcha scriptCaptcha state
    // eslint-disable-next-line no-unused-vars
    const [scriptCaptcha, setScriptCaptcha] = useState('');

    // Handlers
    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleChange = (prop) => (e) => {
        prop === 'recovery' ? setValues({ ...values, errorEmail: false }) : setValues({ ...values, errorLogin: false });
        setLoginForm({ ...loginForm, [prop]: e.target.value });
    };

    const handleForgot = () => setForgotPass(!forgotPass);

    const handleSubmitForget = e => {
        e.preventDefault();
        if (!loginForm.recovery) {
            return false;
        }
        setIsLoading(true);

        const body = {
            idPlatform: platforms.backoffice,
            email: loginForm.recovery,
            metadata: {
                locale: getCoreLocale(i18n.resolvedLanguage)
            }
        };

        loginService
            .forgot(body)
            .then(response => {
                setIsLoading(false);
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'success',
                    title: t('login.forgot.success'),
                    className: 'clientsMC_Alert--success'
                }));
                setOpenAlert(true);
            })
            .catch(error => {
                setIsLoading(false);
                setValues({ ...values, errorEmail: true });
                console.error(error);
            });
    };

    const handleSubmit = e => {
        setIsLoading(true);

        loginService
            .login(loginForm.account, loginForm.password, captchaToken)
            .then(user => {
                if (user.status.description === 'recovery') {
                    const data = {
                        idPlatform: user.id_platform,
                        document: user.person.document.description,
                        email: user.person.email.description,
                        wasBlocked: true,
                        metadata: {
                            locale: getCoreLocale(i18n.resolvedLanguage)
                        }
                    };
                    // crear el token de forgot
                    loginService
                        .forgot(data)
                        .then((res) => {
                            setIsLoading(false);
                            window.location.assign(res.url);
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
                else {
                    setIsLoading(false);
                    localStorage.setItem('sessionUser', JSON.stringify(user));
                    props.login(user.token.accessToken || user.token.access_token);

                    const initialRoute = getInitialRoute(user);
                    history.push(initialRoute);
                }
            })
            .catch(error => {
                setIsLoading(false);
                console.error(error);
                setValues({ ...values, errorLogin: true });
            });
    };

    // Si quieres agregar la verificación de reCAPTCHA Enterprise a una interacción de usuario, haz lo siguiente:
    const login = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!loginForm.account || !loginForm.password) {
            setIsLoading(false);
            return false;
        }

        return window.grecaptcha.enterprise.ready(function () {
            // execute return a token
            window.grecaptcha.enterprise.execute(SITE_KEY, { action: 'LOGIN' })
                .then(token => {
                    // recaptcha.captchaToken = token;
                    captchaToken = token;
                    // login
                    handleSubmit(token);
                })
                .catch(error => {
                    setIsLoading(false);
                    console.error({ error });
                });
        });
    };

    // useEffect

    useEffect(() => {
        if (recoverPassword) {
            history.push(recoverPassword);
            localStorage.removeItem('recoverToken');
            return;
        }

        createCaptcha(setScriptCaptcha, SITE_KEY);
        showCaptcha();
        return () => {
            deletCaptcha();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid container component="main" style={{ height: '100vh' }}>
            <CustomAlert
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                alert={alert}
                setAlert={setAlert}
            />
            <CssBaseline />
            <Grid className="natura-login-left" item xs={6} sm={6} md={6} >
                <LoginSVG />
            </Grid>
            <Grid className="natura-login-right" item xs={6} sm={6} md={6} sx={{ position: 'relative' }}>
                <LanguageSelector className={{ top: 4, right: 4, position: 'absolute' }} />
                <Box className="login">
                    <Box display='flex' flexDirection='column' justifyContent='flex-start' className="login_card" hidden={forgotPass}>
                        <Box display='flex' flexDirection='column' alignItems='flex-start' justifyContent='space-between' height='130px' marginBottom='16px'>
                            <Box className="login_chip"><span className="login_chip--text">{t('login.general.chip')}</span>
                            </Box>
                            <Box className="login_profile--icon"><ProfileSVG /></Box>
                        </Box>
                        <Typography className="login_card--title" >
                            {t('login.title')}
                        </Typography>
                        <Box display='flex' flexDirection='column' justifyContent='space-between' minHeight='20rem' marginTop='3.077rem'>
                            <TextField onChange={handleChange('account')}
                                placeholder= {t('login.inputs.email.label')}
                                fullWidth
                                color="secondary"
                                required
                                autoComplete="off"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><EmailSVG customStroke={palette.tertiary[500]} /></InputAdornment>,
                                }}
                                variant="outlined"
                                className='mb-3'
                            />
                            <FormControl required variant="outlined" >
                                <OutlinedInput
                                    onChange={handleChange('password')}
                                    color="secondary"
                                    placeholder= {t('login.inputs.password.label')}
                                    fullWidth
                                    autoComplete="current-password"
                                    type={values.showPassword ? 'text' : 'password'}
                                    value={loginForm.password}
                                    className='mb-3'
                                    startAdornment={<InputAdornment position="start"><LockSVG color={palette.tertiary[500]} /></InputAdornment>}
                                    endAdornment={<InputAdornment position="end" >
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                            size="large">
                                            {values.showPassword ? <ShowPasswordSVG /> : <ShowPasswordOffSVG />}
                                        </IconButton>
                                    </InputAdornment>}
                                />
                                {values.errorLogin && (
                                    <Typography className="login_error--message">
                                        {t('login.error')}
                                    </Typography>
                                )}
                                <Link className="login_forgot_password--link" variant="body2" onClick={handleForgot}>
                                    {t('login.forgot.title')}
                                </Link>
                            </FormControl>
                            <Box marginTop='auto'>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    className='login_submit--button'
                                    onClick={login}
                                    disabled={(!loginForm.password || !loginForm.account) || isLoading}
                                >
                                    {isLoading ? (<CircularProgress size={24} style={{ color: 'white' }} />) : t('buttons.login')}
                                </Button>
                            </Box>

                        </Box>
                    </Box>
                    <Box display='flex' flexDirection='column' justifyContent='flex-start' className="login_card" hidden={!forgotPass}>
                        <Box display='flex' flexDirection='column' alignItems='space-between' justifyContent='space-between' height='130px' marginBottom='16px'>
                            <Box display='flex' flexDirection='row' alignItems='space-between' justifyContent='end' >
                                <Box className="login_chip">
                                    <span className="login_chip--text">{t('login.general.chip')}</span>
                                </Box>
                            </Box>
                            <Box className="login_profile--icon"><ProfileSVG /></Box>
                        </Box>
                        <Typography className="login_card--title" >
                            {t('login.forgot.title')}
                        </Typography>
                        <Typography className="login_forgot_password--text" >
                            {t('login.forgot.description')}
                        </Typography>
                        <Typography className='login_forgot_password--message' >
                            {t('login.inputs.email.tip')}
                        </Typography>
                        <FormControl required variant="outlined" >
                            <TextField
                                variant="outlined"
                                className='mb-3'
                                required
                                fullWidth
                                placeholder="Email"
                                name="account"
                                autoComplete="off"
                                autoFocus
                                color="secondary"
                                onChange={handleChange('recovery')}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><EmailSVG customStroke={palette.tertiary[500]} /></InputAdornment>,
                                }}
                            />
                            {values.errorEmail && (<Box ><Typography className="login_error--message" >
                                <Trans i18nKey={t('login.forgot.error')} />
                            </Typography>
                            </Box>)}
                        </FormControl>
                        <Box marginTop='auto'>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className='login_submit--button'
                                onClick={handleSubmitForget}
                                disabled={(!loginForm.recovery) || isLoading}
                            >
                                {isLoading ? (<CircularProgress size={24} style={{ color: 'white' }} />) : t('buttons.sendEmail')}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default
connect(
    null,
    auth.actions
)(Login);
